// NOTE:
// - Local API: http://localhost:5000/api
// - Live API (AWS behind /api_new): https://getbettertransportation.com/api_new/api
export const BASE_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:5000/api"
    : "https://getbettertransportation.com/api_new/api";

// Some deployments expose routes under `${BASE_URL}/api/*` (e.g. /api_new/api/notifications).
// Keep BASE_URL for existing endpoints, but normalize API subpath for notifications endpoints.
const API_BASE = (() => {
  const b = String(BASE_URL || "").replace(/\/+$/, "");
  if (b.endsWith("/api")) return b;
  return `${b}/api`;
})();

export const UPDATE_NOTIFICATION_URL = `${API_BASE}/notification_update`
export const GET_NOTIFICATIONS_URL = `${API_BASE}/notifications`

// Public profile + static assets are served under `/api/*` on the backend.
export const PUBLIC_PROFILE_URL = `${API_BASE}/public_profile`
export const IMAGES_URL = `${API_BASE}/images`
// Migrated / new local uploads: /api/uploads/<folder>/<file>
export const UPLOADS_URL = `${API_BASE}/uploads`
export const SAVE_FREE_RIDE_URL = `${BASE_URL}/free_ride`
export const SAVE_DRIVE_WITH_US_URL = `${BASE_URL}/drive_with_us/save`
export const SAVE_PARTNER_WITH_US_URL = `${BASE_URL}/partner_with_us/save`
export const CHECK_USER_URL = `${BASE_URL}/user/check`
export const LOGIN_URL = `${BASE_URL}/user/login`
export const USER_UPDATE_URL = `${BASE_URL}/user/proile/update`
export const USER_FORGOT_PASSWORD_URL = `${BASE_URL}/user/forgot_password`
export const USER_NEW_PASSWORD_URL = `${BASE_URL}/user/new_password`
export const GET_DRIVE_WITH_US_URL = `${BASE_URL}/drive_with_us/get`
export const DRIVE_WITH_US_UPDATE = `${BASE_URL}/drive_with_us/file_update`
export const GET_PARTNER_WITH_US_URL = `${BASE_URL}/partner_with_us/get`
export const GET_FREE_RIDE_URL = `${BASE_URL}/free_ride/get`
export const GET_USER_PROFILE = `${BASE_URL}/user/profile/get`
export const UPLOAD_FILE_URL = `${BASE_URL}/file/upload`
export const GET_W9_TEMPLATE_URL = `${BASE_URL}/file/w9-template`
export const SAVE_ACCOUNT_INFO = `${BASE_URL}/save-account`
export const GET_ACCOUNT  =`${BASE_URL}/account/get`
export const UPDATE_ACCOUNT  =`${BASE_URL}/account/upate`
